export const enum TIMER_STATE {
  SettingUp = "SETTINGUP", // When the time is being input
  Started = "STARTED", // When "START" button is pressed
  Running = "RUNNING", // When timer is counting down
  Paused = "PAUSED", // When 'PAUSE' button is clicked while timer is running
  Resumed = "RESUMED", // When 'RESUME' button is clicked while timer is paused
  Stopped = "STOPPED", // When timer runs out
  Reset = "RESET", // When 'RESET' button clicked
  Restart = "RESTART", // When 'RESTART' button clicked after reset
  AboutToEnd = "ENDING", // Just before the timer stops
}
